import { createApi } from '@reduxjs/toolkit/query/react';

import { SortOrder } from 'utils/enums';
import { baseQueryWithReauth } from 'utils/services';

import {
  CheckPrescriptionEligibilityReqProps,
  GetAdminPrescriptionsReqProps,
  GetAdminPrescriptionsResProps,
  GetMedicalRecordsDataProps,
  GetMedicalRecordsReqProps,
  GetMedicalRecordsResProps,
  GetMpMagicLinkReqProps,
  GetMpMagicLinkResProps,
  GetPrescriptionsReqProps,
  GetPrescriptionsResProps,
  RequestRenewalReqProps,
  RequestRenewalResProps
} from './patientChart.types';

export const patientChartApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    checkPrescriptionEligibility: build.mutation<unknown, CheckPrescriptionEligibilityReqProps>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/prescriptions/renewal/eligibility'
      })
    }),
    getAdminPrescriptions: build.query<
      GetAdminPrescriptionsResProps,
      GetAdminPrescriptionsReqProps
    >({
      keepUnusedDataFor: 0,
      query: (patientId) => `patients/${patientId}/prescriptions`
    }),
    getMedicalRecords: build.query<GetMedicalRecordsDataProps, GetMedicalRecordsReqProps>({
      keepUnusedDataFor: 0,
      query: (patientId) => `patients/${patientId}/my-chart`,
      transformResponse: (response: GetMedicalRecordsResProps) => response.data
    }),
    getMpMagicLink: build.query<GetMpMagicLinkResProps, GetMpMagicLinkReqProps>({
      query: (patientId) => `/patients/${patientId}/mp-magic-link`
    }),
    getPrescriptions: build.query<GetPrescriptionsResProps, GetPrescriptionsReqProps | void>({
      keepUnusedDataFor: 0,
      query: (params) => ({
        params: { sortField: 'signedDate', sortOrder: SortOrder.Desc, ...params },
        url: '/patient-chart/prescriptions'
      })
    }),
    requestRenewal: build.mutation<RequestRenewalResProps, RequestRenewalReqProps>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/prescriptions/renewal/request'
      })
    })
  }),
  reducerPath: 'patientChartApi',
  tagTypes: ['patientChart']
});

export const {
  useCheckPrescriptionEligibilityMutation,
  useGetAdminPrescriptionsQuery,
  useGetMedicalRecordsQuery,
  useGetPrescriptionsQuery,
  useLazyGetMpMagicLinkQuery,
  useLazyGetPrescriptionsQuery,
  useRequestRenewalMutation
} = patientChartApi;
